import { component } from 'picoapp';
import { debounce } from 'lodash-es';

export default component((node, ctx) => {
  const styles = node.querySelector('[data-filter-group="active"]');
  const announcement = document.querySelector('#shopify-section-announcement');
  const header = document.querySelector('[data-header]');

  const selector = window.theme.template !== 'search' ? node : node.parentNode;
  const headerHeight = header.offsetHeight;

  const { scrollY } = window;
  const { top: topValue } = selector.getBoundingClientRect();
  const position = scrollY > selector.offsetTop ? scrollY - Math.abs(topValue) : topValue;

  const buffer = 30;
  const bufferThreshold = 3;

  const setHeaderHeight = headerHeight + (buffer / bufferThreshold);
  document.documentElement.style.setProperty('--header-height', `${setHeaderHeight}px`);

  function sticky(topPos = null) {
    const posTop = topPos ?? position;

    if (window.scrollY + headerHeight - buffer > posTop - announcement.offsetHeight) {
      node.parentNode.classList.add('sticky-filter');
      node.classList.add('is-sticky');
    } else {
      node.parentNode.classList.remove('sticky-filter');
      node.classList.remove('is-sticky');
    }
  }

  // Run on load
  sticky(position);

  window.addEventListener('scroll', () => {
    sticky();
  });

  window.addEventListener('resize', debounce(() => {
    const { top } = selector.getBoundingClientRect();
    sticky(top);
  }), 300);

  /**
   * Hide default showing filters when hovering other filter groups
   */

  if (styles) {
    ctx.on('filter:hover', (state, hover) => {
      if (window.innerWidth < 1279) return;

      if (hover) styles.classList.remove('is-active');
      else styles.classList.add('is-active');
    });
  }

  const rows = node.querySelectorAll('[data-filter-row]');

  rows.forEach((row) => {
    const trigger = row.querySelector('[data-filter-row-trigger]');
    const group = row.querySelector('[data-filter-group]');
    const clear = row.querySelector('[data-filter-clear-group]');

    row.addEventListener('mouseover', () => {
      ctx.emit('filter:hover', null, true);
    });

    row.addEventListener('mouseleave', () => {
      ctx.emit('filter:hover', null, false);
    });

    // Toggle filters
    if (trigger) {
      trigger.addEventListener('click', () => {
        row.classList.toggle('is-visible');
        group.style.height = row.classList.contains('is-visible') ? `${group.scrollHeight}px` : 0;
      });
    }

    // Clear group filters
    if (clear) {
      clear.addEventListener('click', () => {
        group.querySelectorAll('[data-filter-item]').forEach((item) => item.classList.remove('is-active'));
        ctx.emit('filter:start');
      });
    }
  });

  /**
   * Keep current URL param as active filter on next page
   */

  const keepParamsLinks = node.querySelectorAll('[data-keepurl]');
  keepParamsLinks.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const { keepurl } = item.dataset;

      const params = new URLSearchParams(window.location.search);
      const value = params.get(keepurl);

      const url = value ? `?${keepurl}=${value}` : '';
      window.location = keepurl === 'all' ? item.href : item.href + url;
    });
  });
});
